import { contributorConnectionService } from "../../../services/connections/contributorService";
import { SystemEntityCollections } from "../../../shared/enums/shared-enums";
import {
  ContributorConnection,
  SystemContributorTypes,
} from "../../../types/contributor";
import useContributorLogic from "../../logic/connections/contributorLogic";
import useConnectionQueryClient from "./connectionQueryClient";

const useContributorQuery = (
  type: SystemContributorTypes,
  systemLanguageType: ContributorConnection["system_language_type"]
) => {
  const { defaultContributor, getDisplayName } = useContributorLogic(
    null,
    null,
    type,
    systemLanguageType
  );
  return useConnectionQueryClient<ContributorConnection>({
    service: contributorConnectionService,
    collection: SystemEntityCollections.CONTRIBUTOR,
    defaultConnection: defaultContributor,
    snackbarDisplayName: getDisplayName,
  });
};

export default useContributorQuery;
